import { render } from "./productGroup.vue?vue&type=template&id=63adece1&scoped=true"
import script from "./productGroup.vue?vue&type=script&lang=js"
export * from "./productGroup.vue?vue&type=script&lang=js"

import "./productGroup.vue?vue&type=style&index=0&id=63adece1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63adece1"]])

export default __exports__